{
  "name": "@globalleaderboards/sdk",
  "version": "0.5.0",
  "description": "Official SDK for GlobalLeaderboards.net - Add competitive leaderboards to any application",
  "main": "dist/index.js",
  "module": "dist/index.mjs",
  "types": "dist/index.d.ts",
  "files": [
    "dist",
    "README.md"
  ],
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "docs": "yarn docs:html && yarn docs:markdown",
    "docs:html": "typedoc --options typedoc-html.json",
    "docs:markdown": "typedoc --options typedoc-markdown.json",
    "docs:watch": "typedoc --options typedoc-html.json --watch",
    "lint": "tsc --noEmit",
    "prepublishOnly": "yarn build",
    "test": "vitest",
    "test:coverage": "vitest run --coverage",
    "typecheck": "tsc --noEmit"
  },
  "keywords": [
    "leaderboards",
    "gaming",
    "highscores",
    "sdk",
    "api",
    "realtime",
    "websocket",
    "competitive"
  ],
  "author": "GlobalLeaderboards.net",
  "license": "MIT",
  "repository": {
    "type": "git",
    "url": "git@github.com:GlobalLeaderboards/sdk.git"
  },
  "bugs": {
    "url": "https://github.com/GlobalLeaderboards/sdk/issues"
  },
  "homepage": "https://globalleaderboards.net",
  "dependencies": {
    "ulid": "^2.3.0"
  },
  "devDependencies": {
    "@types/node": "^20.0.0",
    "@typescript-eslint/eslint-plugin": "^6.0.0",
    "@typescript-eslint/parser": "^6.0.0",
    "@vitest/coverage-v8": "^1.0.0",
    "barva": "^1.1.0",
    "eslint": "^8.0.0",
    "tsup": "^8.0.0",
    "typedoc": "^0.28.7",
    "typedoc-plugin-markdown": "^4.7.1",
    "typescript": "^5.0.0",
    "vitest": "^1.0.0"
  },
  "engines": {
    "node": ">=16.0.0"
  },
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org/"
  }
}
